import { createStore, compose, applyMiddleware } from 'redux';
import tron from '../config/ReactotronConfig';

export default (reducers, middlewares) => {
  const enhancer =
    process.env.NODE_ENV === 'development'
      ? compose(
        tron.createEnhancer(),
        applyMiddleware(...middlewares)
      )
      : applyMiddleware(...middlewares);

  return createStore(reducers, enhancer);
};